<div
	class="flex flex-wrap justify-between items-end mb-3 rounded"
	*ngIf="showRepresentationOption"
>
	<app-radio-group
		label="Representation type"
		[items]="items"
		[(ngModel)]="selectedRepresentation"
		name="representation"
		type="compact"
		[testHook]="testHooks.RepresentationTypeRadioGroup"
	></app-radio-group>
	<div class="sm:mt-4">
		<app-checkbox
			label="Primary contact"
			name="primary"
			[(ngModel)]="primary"
			*ngIf="showPrimaryClientOption"
			[testHook]="testHooks.PrimaryContactCheckbox"
		></app-checkbox>
	</div>
</div>
<div *ngIf="(createStatus$ | async) !== createStatusType.success">
	<form #form="ngForm" (ngSubmit)="onSubmit(form)" class="flex flex-col">
		<app-container type="dark" size="small" [testHook]="testHooks.Container">
			<div>
				<div class="flex-col flex">
					<div
						[ngClass]="{
							'flex flex-col': !minify,
							'flex flex-1 gap-2': minify,
						}"
					>
						<app-dropdown
							label="Title"
							name="title"
							[(ngModel)]="_title"
							[itemGroups]="[{ items: titleOptions }]"
							[submitted]="form.submitted"
							(onSelect)="selectTitle($event)"
							[ngClass]="{
								'mr-2': !minify,
								hidden: minify,
								'flex-none': !minify,
								'w-20 mt-4': !minify,
							}"
							[testHook]="testHooks.TitleDropdown"
						></app-dropdown>
						<app-input
							label="First name"
							name="firstName"
							type="text"
							[required]="true"
							[(ngModel)]="_firstName"
							[submitted]="form.submitted"
							[ngClass]="{ 'mr-2 mt-4': !minify, grow: !minify }"
							[testHook]="testHooks.FirstName"
						></app-input>
						<app-input
							label="Middle name(s)"
							name="middleNames"
							type="text"
							[(ngModel)]="_middleNames"
							[submitted]="form.submitted"
							[ngClass]="{ 'mr-2 grow mt-4': !minify }"
							[testHook]="testHooks.MiddleNames"
						></app-input>
						<app-input
							label="Last name"
							name="lastName"
							type="text"
							[required]="true"
							[(ngModel)]="_lastName"
							[submitted]="form.submitted"
							[ngClass]="{ 'grow mr-2 mt-4': !minify }"
							[testHook]="testHooks.LastName"
						></app-input>
					</div>
				</div>

				<div [ngClass]="{ 'flex flex-col': !minify, hidden: minify }">
					<app-radio-group
						label="Gender"
						[items]="genderOptions"
						[(ngModel)]="selectedGender"
						name="gender"
						type="compact"
						[submitted]="form.submitted"
						class="flex-1 mr-2 mt-4"
						[testHook]="testHooks.GenderRadioGroup"
					></app-radio-group>
					<app-date-picker
						label="Date of birth"
						[(ngModel)]="dateOfBirth"
						startView="multi-year"
						name="dateOfBirth"
						class="mt-4"
						[testHook]="testHooks.DateOfBirthDatePicker"
					></app-date-picker>
					<app-input
						label="Cell phone"
						name="_phoneNumber"
						type="tel"
						[submitted]="form.submitted"
						[(ngModel)]="_phoneNumber"
						class="flex-1 mr-2 mt-4"
						[testHook]="testHooks.CellPhone"
					></app-input>
					<app-input
						label="Email"
						name="email"
						type="_email"
						[email]="true"
						[submitted]="form.submitted"
						[(ngModel)]="_email"
						class="mt-4 mr-2"
						[testHook]="testHooks.Email"
					></app-input>
				</div>
			</div>
			<div *ngIf="showIDsOption">
				<div class="flex">
					<h4>Identification</h4>
					<app-button
						size="small"
						class="ml-3"
						[icon]="ICON.ADD"
						(click)="addIdentification()"
						*ngIf="_identifications.length < 2"
						[testHook]="testHooks.AddIdButton"
						>Add ID</app-button
					>
				</div>
				<div class="m-5" *ngIf="_identifications?.length > 0">
					<div *ngFor="let identification of _identifications; let i = index">
						<app-container type="dark" [testHook]="testHooks.Container1">
							<app-base-identification-form
								[identification]="identification"
								[clientName]="getClientFullName"
								(identificationUpdated)="updateIdentification(i, $event)"
							></app-base-identification-form>
						</app-container>
					</div>
				</div>
			</div>
		</app-container>
		<div class="flex justify-between mt-4">
			<app-button
				btn="secondary"
				size="small"
				(click)="cancel()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button
				type="submit"
				size="small"
				[loading]="(createStatus$ | async) === createStatusType.creating"
				[disabled]="(createStatus$ | async) === createStatusType.creating"
				[testHook]="testHooks.SaveButton"
				>Save</app-button
			>
		</div>
	</form>
	<div *ngIf="(createStatus$ | async) === createStatusType.failed" class="mt-4">
		Unable to create new client. Please try again.
	</div>
</div>
